import React from "react";
import { Breadcrumb } from "antd";
import Link from "next/link";
import { withRouter } from "next/router";
import { type IInjectProps } from "@aspen/model";
import { getQueryValue, i18nUtil, PORTFOLIO_PATHS } from "@aspen/libs";
import { History } from "@aspen/widgets";

class WalletHistory extends React.Component<IInjectProps> {
  constructor(props: IInjectProps) {
    super(props);
  }

  render(): React.ReactNode {
    const intl = i18nUtil.t();
    const location: string = intl["kyc.certify.location"];
    const wallet: string = intl["wallet"];
    const history = intl["wallet.history"];
    const type = getQueryValue("type");
    const currency = getQueryValue("currency");
    const fiat = getQueryValue("fiat");

    return (
      <>
        <Breadcrumb style={{ marginBottom: "24px" }}>
          <Breadcrumb.Item>{location}:</Breadcrumb.Item>
          <Breadcrumb.Item>
            <Link href={PORTFOLIO_PATHS.PORTFOLIO_WALLET}>{wallet}</Link>
          </Breadcrumb.Item>
          <Breadcrumb.Item>{history}</Breadcrumb.Item>
        </Breadcrumb>
        <History
          showViewAll={false}
          type={Number(type)}
          currency={currency?.toString()}
          fiat={Boolean(fiat)}
        />
      </>
    );
  }
}
export const PageWalletHistory = withRouter(WalletHistory);
